import { render, staticRenderFns } from "./AIViewDocument.vue?vue&type=template&id=4a49ea1e&scoped=true"
import script from "./AIViewDocument.vue?vue&type=script&lang=js"
export * from "./AIViewDocument.vue?vue&type=script&lang=js"
import style0 from "./AIViewDocument.vue?vue&type=style&index=0&id=4a49ea1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a49ea1e",
  null
  
)

export default component.exports